// Kreisgeometrie fuer die Karte: einmal laden, lange behalten. Kommt aus
// /api/regions/bundle (nur geom_simple, nie die volle Geometrie, siehe
// Server-Kommentar).

import { useQuery } from "@tanstack/react-query";
import { holeBundleMitCache } from "./offlineBundle.js";

export interface Region {
  ags: string;
  name: string;
  geomSimple: GeoJSON.Geometry;
  bbox: [number, number, number, number];
  plateCodeIds: number[];
}

export function useRegionsBundle() {
  return useQuery({
    queryKey: ["regions-bundle"],
    // Wie die Kennzeichen-Stammdaten: aendert sich praktisch nie waehrend
    // eine Sitzung laeuft.
    staleTime: 30 * 60 * 1000,
    queryFn: () => holeBundleMitCache<{ regionen: Region[] }>("regions", "/regions/bundle"),
  });
}
